import { Requirement } from "../../types/requirement.response";
import { AddableCourse, CourseLite } from "../../types/course.response";
import { CourseRequirementOverride } from "../../services/api/user-courses.api";

type AddCourse = (newCourse: AddableCourse, overrides: CourseRequirementOverride[], semester: string | null, classSectionIds?: number[]) => void | Promise<void>;
type Override = (course: CourseLite, override: CourseRequirementOverride) => void | Promise<void>;

/**
 * 把已修课程 force-apply 到指定节点;无 nodeId 时按普通加课处理。
 * ReqSectionHeader 及各 option 面板共用这套逻辑。
 */
export function useForceApplyAdd(requirement: Requirement, handleAddCourse: AddCourse, handleOverride: Override) {
    return async (course: AddableCourse, nodeId: string | null) => {
        if (nodeId && course.userItemId) {
            await handleOverride(course, {
                requirementId: requirement.info.id,
                nodeId,
                overrideType: "FORCE_APPLY",
            });
            return;
        }
        await handleAddCourse(
            course,
            nodeId ? [{ requirementId: requirement.info.id, nodeId, overrideType: "FORCE_APPLY" }] : [],
            null,
        );
    };
}
